import { ValidationError } from 'joi'
import { type AuthenticateError } from '@/types/AuthenticateError'

/**
 * Formats a Joi validation error format into an SDK error.
 *
 * @param {ValidationError} error - Joi validation error
 * @returns {AuthenticateError}
 */
export default function formatValidationError(error: ValidationError): AuthenticateError {
  const details = error.details.map((detail) => ({
    message: detail.message,
    reason: 'INVALID_VALUE',
    source: detail.context?.label,
    sourceType: detail.type
  }))

  return {
    name: 'authError',
    reason: 'INVALID_PARAMETER',
    details
  }
}
